import { useState } from "react";
import ShippingAPIDataSourceImpl from "../../Data/DataSource/API/ShippingAPIDataSource";
import { ShippingRepositoryImpl } from "../../Data/Repository/ShippingRepositoryImpl";
import { ShippingRateLima } from "../../Domain/Model/ShippingRateLima";
import { ShippingRateProvince } from "../../Domain/Model/ShippingRateProvince";
import { GetShippingRatesLima } from "../../Domain/UseCase/GetShippingRatesLima";
import { GetShippingRatesProvince } from "../../Domain/UseCase/GetShippingRatesProvince";

export default function ShippingViewModel() {

    const [shippingRatesProvince, setShippingRatesProvince] = useState<ShippingRateProvince[]>([]);
    const [shippingRatesLima, setShippingRatesLima] = useState<ShippingRateLima[]>([]);

    const shippingDataSourceImpl = new ShippingAPIDataSourceImpl();
    const shippingRepositoryImpl = new ShippingRepositoryImpl(shippingDataSourceImpl);

    const getShippingRatesProvinceUseCase = new GetShippingRatesProvince(shippingRepositoryImpl);
    const getShippingRatesLimaUseCase = new GetShippingRatesLima(shippingRepositoryImpl);

    async function getShippingRatesProvince() {
        try {
            const rates = await getShippingRatesProvinceUseCase.invoke();
            setShippingRatesProvince(rates);
            return rates;
        } catch (e) {
            if (e instanceof Error) {
                console.log(e.message);
            }
            return [];
        }
    }

    async function getShippingRatesLima() {
        try {
            const rates = await getShippingRatesLimaUseCase.invoke();
            setShippingRatesLima(rates);
            return rates;
        } catch (e) {
            if (e instanceof Error) {
                console.log(e.message);
            }
            return [];
        }
    }

    return {
        getShippingRatesProvince,
        getShippingRatesLima,
        shippingRatesProvince,
        shippingRatesLima,
    };
}